import script from "./product-card-type-f.vue?vue&type=script&setup=true&lang=js"
export * from "./product-card-type-f.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__